module.exports = __webpack_public_path__ + "img/cloudy.ec1365ca.svg";